<div class="collapse-wrapper">
    @if (!isLayout12()) {
    <div class="title-section">
        <a (click)="hideMenu$.emit(true)" class="mobile-sub-menu" [target]="menuItem().target" [attr.data-click_action_value]="menuItem()['data-click_action_value']" [attr.data-click_action_choice]="menuItem()['data-click_action_choice']">
            <label>{{ menuItem().text }} </label>
        </a>

        <img [ngClass]="!collapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon" />
    </div>
    }

    <!-- Layout-12 specific HTML -->
    @if (isLayout12()) {
    <div class="title-section layout-12-child-specific">
        <div class="submenu-content">
            <!-- Add image for sub-category -->
            <div class="layout-12-submenu-content-image-wrapper">
                <div class="submenu-image-wrapper">
                    <img [id]="menuItem().id" [src]="menuItem().categoryImage || IMAGE_URLS.productEmptyState" class="submenu-category-image" [attr.data-click_action_value]="menuItem()['data-click_action_value']" [attr.data-click_action_choice]="menuItem()['data-click_action_choice']" />
                </div>

                <a class="mobile-sub-menu layout-12-submenu" [target]="menuItem().target" [attr.data-click_action_value]="menuItem()['data-click_action_value']" [attr.data-click_action_choice]="menuItem()['data-click_action_choice']">
                    <label [id]="menuItem().id" class="editable static-header layout-12-submenu-label">{{ menuItem().text }}
                    </label>
                </a>
            </div>
            <img [ngClass]="!collapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon" />
        </div>
    </div>
    }

    <div [@collapse]="collapsed()">
        <ng-content></ng-content>
    </div>
</div>